import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import Input from 'base/react/components/form/input'
import SiteLocation from 'base/constants/site_location'
import Button from '@everlane/button'
import FadeInOut from 'base/react/animations/fade_in_out'
import LoadingAnimation from 'base/react/components/loading_animation'
import Radio from 'base/react/components/form/radio'
import EyeActive from 'base/components/ui/eye-active'
import EyeInactive from 'base/components/ui/eye-inactive'
import Cookies from 'js-cookie'
import { SHOW_GDPR_EMAIL_OPTIN } from 'cookies.yml'

export class SignUpForm extends Component {
  static propTypes = {
    initialEmail: PropTypes.string,
    onSubmit: PropTypes.func,
    errors: PropTypes.object,
    ctaText: PropTypes.string,
    refreshParentScroller: PropTypes.func,
    defaultOptIn: PropTypes.bool,
    isLoading: PropTypes.bool,
    siteLocation: PropTypes.string,
  }

  static defaultProps = {
    ctaText: 'Sign Up',
    defaultOptIn: true,
  }

  // Lifecycle

  constructor(props) {
    super(props)

    this.state = {
      passwordRevealed: false,
      formValues: {
        email: props.initialEmail || '',
        password: '',
        gender: get(this.props, 'visitor.gender', ''),
      },
      optIntoEmails: props.defaultOptIn,
    }
  }

  componentDidMount() {
    if (this.props.refreshParentScroller) {
      this.props.refreshParentScroller()
    }
  }

  componentDidUpdate() {
    if (this.props.refreshParentScroller) {
      this.props.refreshParentScroller()
    }
  }

  // Event Handling

  handleSubmit = event => {
    event.preventDefault()

    this.props.onSubmit &&
      this.props.onSubmit({
        ...this.state.formValues,
        password: this.state.formValues.password,
        email_optout: this.state.optIntoEmails ? undefined : true,
      })
  }

  // Rendering

  renderPasswordRevealIcon() {
    const togglePassword = () => this.setState({ passwordRevealed: !this.state.passwordRevealed })

    return (
      <div onClick={togglePassword} className="login__password-reveal">
        {this.state.passwordRevealed ? <EyeActive /> : <EyeInactive />}
      </div>
    )
  }

  renderEmailFieldset() {
    const onChange = event =>
      this.setState({
        formValues: {
          ...this.state.formValues,
          email: event.currentTarget.value,
        },
      })

    return (
      <Input
        required
        error={this.props.errors && this.props.errors.email}
        id="email"
        inputClass="login__input"
        wrapperClass="login__email-container"
        onChange={onChange}
        placeholder="Email Address"
        type="email"
        value={this.state.formValues.email}
      />
    )
  }

  renderPasswordFieldset() {
    const onChange = event =>
      this.setState({
        formValues: {
          ...this.state.formValues,
          password: event.currentTarget.value,
        },
      })
    const inputType = this.state.passwordRevealed ? 'text' : 'password'

    return (
      <div className="login__password-container">
        <Input
          required
          error={this.props.errors && this.props.errors.password}
          id="password"
          inputClass="login__input"
          name="password"
          onChange={onChange}
          placeholder="Password"
          type={inputType}
          value={this.state.formValues.password}
        />
        {this.renderPasswordRevealIcon()}
      </div>
    )
  }

  renderGenderPicker() {
    const { gender } = this.state.formValues
    const setGender = gender =>
      this.setState({
        formValues: { ...this.state.formValues, gender: gender },
      })
    return (
      <div className="login__radio-container">
        <p className="login__radio-header">What styles are you interested in?</p>
        <div className="login__radio">
          <Radio checked={gender === 'female'} onChange={() => setGender('female')}>
            <p className="login__radio-label">Women</p>
          </Radio>
          <Radio checked={gender === 'male'} onChange={() => setGender('male')}>
            <p className="login__radio-label">Men</p>
          </Radio>
        </div>
      </div>
    )
  }

  renderOptOutEmailFieldset() {
    return (
      <div
        onClick={() => {
          this.setState({ optIntoEmails: !this.state.optIntoEmails })
        }}
      >
        <Input
          type="checkbox"
          labelClass="gdpr__opt-out-checkbox--label"
          label="I’d like to get notified about new products, special events and early access to products. I can unsubscribe at any time."
          value={this.state.optIntoEmails}
          name="optOutOfEmails"
        />
      </div>
    )
  }

  render() {
    const button = this.props.isLoading ? (
      <div className="login__loading-animation-container">
        <LoadingAnimation />
      </div>
    ) : (
      <Button
        className="login__button flat-button--full-width"
        type="button"
        onClick={this.handleSubmit}
        variant="rectangle"
        dark
      >
        {this.props.ctaText}
      </Button>
    )

    return (
      <FadeInOut>
        <form className="login--sign-up">
          {this.renderEmailFieldset()}
          {this.renderPasswordFieldset()}
          {this.renderGenderPicker()}
          {Cookies.get(SHOW_GDPR_EMAIL_OPTIN) === 'true' &&
            this.props.siteLocation !== SiteLocation.MOBILE_HOMEPAGE_MODAL &&
            this.renderOptOutEmailFieldset()}
          {button}
        </form>
      </FadeInOut>
    )
  }
}

function mapStateToProps(state) {
  return {
    visitor: state.session.visitor,
  }
}
export default connect(mapStateToProps)(SignUpForm)
